import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import api from '@/api';
import util from '@/libs/util';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'AgencyPromotionEdit',
  data: function data() {
    return {
      isMobile: false,
      fileList: [],
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      imageUrl: null,
      isEdit: false,
      citys: [],
      agencyMemberSettlementItemEnums: [],
      agentAettlementProportions: [],
      title: '',
      form: {
        agencyPromotionId: null,
        citys: '',
        openTime: '',
        name: '',
        agencyId: null,
        selectCitys: [],
        userName: null,
        passWord: '123456',
        idCard: null,
        phone: null,
        settlementProportion: null,
        openBank: null,
        bankNo: null,
        reference: null,
        nickName: null,
        openBankProvince: null,
        openBankCity: null,
        openBankAreCode: null,
        headImg: null,
        superiorAgent: null
      },
      rules: {
        agencyPromotionId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        citys: [{
          required: true,
          message: '请输入城市属性',
          trigger: 'blur'
        }],
        openTime: [{
          required: true,
          message: '请输入开通时间',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入红娘姓名',
          trigger: 'blur'
        }],
        agencyId: [{
          required: true,
          message: '请输入代理id',
          trigger: 'blur'
        }],
        userName: [{
          required: true,
          message: '请输入登录账号',
          trigger: 'blur'
        }],
        passWord: [{
          required: true,
          message: '请输入初始密码',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }],
        idCard: [{
          required: true,
          message: '请输入身份证号码',
          trigger: 'blur'
        }],
        openBank: [{
          required: true,
          message: '请输入开户行',
          trigger: 'blur'
        }],
        bankNo: [{
          required: true,
          message: '请输入银行账户',
          trigger: 'blur'
        }],
        settlementItems: [{
          required: true,
          message: '请选择结算项目',
          trigger: 'blur'
        }],
        settlementProportion: [{
          required: true,
          message: '请选择分润比例',
          trigger: 'blur'
        }],
        openBankProvince: [{
          required: true,
          message: '请输入收款账号省份',
          trigger: 'blur'
        }],
        openBankCity: [{
          required: true,
          message: '请输入收款账号地市',
          trigger: 'blur'
        }],
        openBankAreCode: [{
          required: true,
          message: '请输入收款账号地区码',
          trigger: 'blur'
        }],
        headImg: [{
          required: true,
          message: '请上传红娘照片',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入红娘昵称',
          trigger: 'blur'
        }],
        superiorAgent: [{
          required: true,
          message: '请输入上级代理',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    cancheUserName: function cancheUserName(e) {
      this.resultMemberInfoApi(e);
      // 红娘账号输入以后，上级代理默认使用红娘账号
      this.form.superiorAgent = e;
    },
    resultMemberInfoApi: function resultMemberInfoApi(e) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, res, obj;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                userName: e
              };
              _context.n = 1;
              return api.resultMemberInfo(data);
            case 1:
              res = _context.v;
              if (res.body.sts) {
                obj = res.body;
                if (obj.member !== null && obj.member !== undefined) {
                  _this.form.name = obj.member.name;
                  _this.form.idCard = obj.member.idNo;
                  _this.form.phone = obj.member.phone;
                  _this.form.headImg = obj.member.headUrl;
                  _this.form.nickName = obj.member.nickName;
                  if (_this.form.headImg.indexOf('http') !== -1) {
                    _this.imageUrl = obj.member.headUrl;
                  } else {
                    _this.imageUrl = _this.downUrl + obj.member.headUrl;
                  }
                }
                if (obj.agencyMember !== null && obj.agencyMember !== undefined) {
                  _this.form.name = obj.agencyMember.name;
                  _this.form.idCard = obj.agencyMember.idCard;
                  _this.form.phone = obj.agencyMember.userName;
                }
                if (obj.agencyPromotion !== null && obj.agencyPromotion !== undefined) {
                  _this.form.name = obj.agencyPromotion.name;
                  _this.form.idCard = obj.agencyPromotion.idCard;
                  _this.form.phone = obj.agencyPromotion.userName;
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    checkMobile: function checkMobile() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var mobileRegex = /(Mobi|Android|iPhone)/i;
      this.isMobile = mobileRegex.test(userAgent);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downUrl + res.body.url;
      this.form.headImg = res.body.url;
    },
    getAgencyMemberSettlementItemEnums: function getAgencyMemberSettlementItemEnums() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'agency_settlement_items'
              });
            case 1:
              res = _context2.v;
              _this2.agencyMemberSettlementItemEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAgentAettlementProportions: function getAgentAettlementProportions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var thiz;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              thiz = _this3;
              _this3.enums.getAgentSettlementProportion(function (result) {
                thiz.agentAettlementProportions = result.body;
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initCitys: function initCitys() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context4.v;
              _this4.citys = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: name
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this5.enumList = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      this.checkMobile();
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.isEdit = false;
      this.form.agencyPromotionId = null;
      this.form.citys = null;
      this.form.openTime = null;
      this.form.name = null;
      this.form.agencyId = null;
      this.form.selectCitys = null;
      this.form.userName = '';
      this.form.passWord = '123456';
      this.form.idCard = null;
      this.form.phone = null;
      this.form.settlementProportion = null;
      this.form.openBank = null;
      this.form.bankNo = null;
      this.form.nickName = null;
      this.form.reference = null;
      this.form.openBankProvince = null;
      this.form.openBankCity = null;
      this.form.openBankAreCode = null;
      this.form.headImg = null;
      this.imageUrl = null;
      this.form.superiorAgent = null;
      this.initCitys();
      this.getAgentAettlementProportions();
      this.getAgencyMemberSettlementItemEnums();
    },
    setData: function setData(data) {
      this.checkMobile();
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.isEdit = true;
      this.getAgentAettlementProportions();
      this.getAgencyMemberSettlementItemEnums();
      this.initCitys();
      this.form.agencyPromotionId = data.agencyPromotionId;
      this.form.citys = data.citys;
      this.form.openTime = data.openTime;
      this.form.name = data.name;
      this.form.selectCitys = JSON.parse(data.citys);
      this.form.agencyId = data.agencyId;
      this.form.userName = data.userName;
      this.form.idCard = data.idCard;
      this.form.phone = data.phone;
      this.form.settlementProportion = data.settlementProportion + '';
      this.form.openBank = data.openBank;
      this.form.bankNo = data.bankNo;
      this.form.nickName = data.nickName;
      this.form.passWord = null;
      this.form.reference = data.reference;
      this.form.openBankProvince = data.openBankProvince;
      this.form.openBankCity = data.openBankCity;
      this.form.openBankAreCode = data.openBankAreCode;
      this.form.headImg = data.headImg;
      this.imageUrl = this.downUrl + '/' + data.headImg;
      // 上级代理已屏蔽：已有挂靠代理时保留原值，否则默认使用红娘账号
      this.form.superiorAgent = data.agencyMember && data.agencyMember.userName ? data.agencyMember.userName : data.userName;
    },
    updateApi: function updateApi() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.UPDATE_AGENCYPROMOTION(_this6.form);
            case 1:
              _this6.$emit('initTableData');
              _this6.$message.success('操作成功');
              _this6.handleClose();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    saveApi: function saveApi() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.SAVE_AGENCYPROMOTION(_this7.form);
            case 1:
              _this7.$emit('initTableData');
              _this7.$message.success('操作成功');
              _this7.handleClose();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    save: function save() {
      var _this8 = this;
      // 上级代理已屏蔽：保存时兜底默认使用红娘账号
      this.form.superiorAgent = this.form.superiorAgent || this.form.userName;
      if (this.form.selectCitys !== null && this.form.selectCitys.length > 0) {
        this.form.citys = JSON.stringify(this.form.selectCitys);
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this8.form.agencyPromotionId != null) {
            _this8.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this8.updateApi();
            }).catch(function () {
              _this8.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this8.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};